__turbopack_context__.v({
  "closeButton": "style-module-scss-module__ostNea__closeButton",
  "closeImage": "style-module-scss-module__ostNea__closeImage",
});
